export enum Stats {
  GET_SITE_PAYOUT_STATS_REQUEST = '@stats/GET_SITE_PAYOUT_STATS_REQUEST',
  GET_SITE_PAYOUT_STATS_SUCCESS = '@stats/GET_SITE_PAYOUT_STATS_SUCCESS',
  GET_SITE_PAYOUT_STATS_FAIL = '@stats/GET_SITE_PAYOUT_STATS_FAIL',

  GET_USER_PAYOUT_STATS_REQUEST = '@stats/GET_USER_PAYOUT_STATS_REQUEST',
  GET_USER_PAYOUT_STATS_SUCCESS = '@stats/GET_USER_PAYOUT_STATS_SUCCESS',
  GET_USER_PAYOUT_STATS_FAIL = '@stats/GET_USER_PAYOUT_STATS_FAIL',

  GET_USER_PAYOUT_STATS_BY_DATE_REQUEST = '@stats/GET_USER_PAYOUT_STATS_BY_DATE_REQUEST',
  GET_USER_PAYOUT_STATS_BY_DATE_SUCCESS = '@stats/GET_USER_PAYOUT_STATS_BY_DATE_SUCCESS',
  GET_USER_PAYOUT_STATS_BY_DATE_FAIL = '@stats/GET_USER_PAYOUT_STATS_BY_DATE_FAIL',

  GET_EMPLOYEE_PAYOUT_STATS_REQUEST = '@stats/GET_EMPLOYEE_PAYOUT_STATS_REQUEST',
  GET_EMPLOYEE_PAYOUT_STATS_SUCCESS = '@stats/GET_EMPLOYEE_PAYOUT_STATS_SUCCESS',
  GET_EMPLOYEE_PAYOUT_STATS_FAIL = '@stats/GET_EMPLOYEE_PAYOUT_STATS_FAIL',
}
